<div [ngClass]="getIconSizeClasses()" #iconContainer></div>
